import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx } from 'react/jsx-runtime';

var Svg18LikeC = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsx("path", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillOpacity: 0.86,
      fillRule: "evenodd",
      d: "M11.007 4.508a2.85 2.85 0 0 0-1.682.712l.116.112A2.8 2.8 0 0 0 7.436 4.5a2.84 2.84 0 0 0-2.04.863 3.23 3.23 0 0 0-.12 4.333c1.08 1.336 3.205 3.137 3.996 3.222l.074.003c.406-.03 1.098-.455 1.832-1.044l.37-.306c.246-.213.494-.439.732-.67l.35-.35c.285-.292.549-.587.774-.865a3.227 3.227 0 0 0-.149-4.322 2.84 2.84 0 0 0-2.04-.864zm.209.992c.497 0 .974.202 1.32.56a2.23 2.23 0 0 1 .098 2.988l-.12.144c-.215.255-.47.526-.74.796l-.33.321-.169.158-.337.305-.33.284c-.54.452-1.015.789-1.242.855l-.046.009c-.085-.01-.267-.114-.506-.283l-.255-.189-.285-.225-.305-.255-.318-.277a21 21 0 0 1-.322-.294l-.319-.302-.306-.306a11 11 0 0 1-.66-.732 2.234 2.234 0 0 1 .073-3 1.84 1.84 0 0 1 2.64.002l.569.49.535-.458c.38-.39.857-.591 1.355-.591"
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18LikeC$1 = Svg18LikeC;

export { Svg18LikeC$1 as default };
